import Vuex from 'vuex'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

var instance

export function setupStore (Vue) {
  Vue.use(Vuex)

  const debug = process.env.NODE_ENV !== 'production'

  instance = new Vuex.Store({
    state: {
      currentUserId: null,
      userData: null,
      blackboard: null,
      ui: {
        errorMsg: null,
        language: null,
        languages: ['de', 'en']
      }
    },
    getters,
    mutations,
    actions,
    strict: debug
  })

  return instance
}



// WEBPACK FOOTER //
// ./src/store/index.js